import Form from '../components/form';

const wooCommerceAccountObject = {};

export default {
  init() {
    wooCommerceAccountObject.form = new Form();
  },

  finalize() {},
};



// WEBPACK FOOTER //
// ./scripts/routes/woocommerce-account.js